/**
 * Timezone-naive datetime formatting for Swapcard schedule display.
 * Times are stored as face-value local times tagged as UTC in the search index.
 * The API serializes them with the server's UTC offset (e.g. "T02:00:00-07:00"
 * for a 9 AM event on a UTC-7 server). Reading UTC hours recovers the intended
 * face-value time regardless of what offset the server applied.
 */
export function formatTime(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (isNaN(d.getTime())) return '';
  const h = d.getUTCHours();
  const m = String(d.getUTCMinutes()).padStart(2, '0');
  const period = h >= 12 ? 'p.m.' : 'a.m.';
  const display = h % 12 || 12;
  return `${display}:${m} ${period}`;
}

export function formatDate(isoString) {
  if (!isoString) return '';
  const match = isoString.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '';
  const [, y, m, d] = match;
  const utc = Date.UTC(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10));
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(utc);
}

export function formatDateFull(isoString) {
  if (!isoString) return '';
  const match = isoString.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '';
  const [, y, m, d] = match;
  const utc = Date.UTC(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10));
  return new Intl.DateTimeFormat('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC',
  }).format(utc);
}
